module.exports = __webpack_public_path__ + "img/btn_next.0f47fea7.png";